module.exports = __webpack_public_path__ + "static/media/9@1280w.f8d6bd2e.jpg";